import { Stitches } from 'src/styles/stitches';

export const ActionConfirmModalHeader = Stitches.styled('div', {
  width: '100%',
});

export const ActionConfirmModalWrapper = Stitches.styled('div', {
  width: '100%',
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'start',
  gap: '$5',
});

export const ActionConfirmModalWrapperContent = Stitches.styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'start',
});

export const ActionConfirmModalActions = Stitches.styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '$1',
});

export const Description = Stitches.styled('span', {
  color: '$gray400',
  textAlign: 'start',
});
